import React, { useState } from 'react';

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

import { useClearOfferMetaCache } from '~/hooks/apis/promo/useClearOfferMetaCache';

export default function OfferMetaCache() {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const { mutateAsync, isPending, isSuccess, data, error, reset } = useClearOfferMetaCache();

  function openConfirmation() {
    reset();
    setIsConfirmOpen(true);
  }

  function closeConfirmation() {
    if (!isPending) setIsConfirmOpen(false);
  }

  async function clearCache() {
    try {
      await mutateAsync();
      setIsConfirmOpen(false);
    } catch {
      // Keep the confirmation open so the error is visible and the action can be retried.
    }
  }

  return (
    <Stack spacing={2} alignItems="flex-start">
      <Typography>Clear cached offer metadata used by the promo service.</Typography>
      {isSuccess && (
        <Alert severity="success">Offer metadata cache cleared. Deleted keys: {data.result.deletedKeys}.</Alert>
      )}
      <Button variant="contained" color="primary" onClick={openConfirmation} disabled={isPending}>
        Clear offer metadata cache
      </Button>
      <Dialog open={isConfirmOpen} onClose={closeConfirmation} aria-labelledby="clear-offer-meta-cache-title">
        <DialogTitle id="clear-offer-meta-cache-title">Clear offer metadata cache?</DialogTitle>
        <DialogContent>
          <DialogContentText>This will clear the offer metadata cache used by the promo service.</DialogContentText>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              Failed to clear the cache: {error.message}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="text" onClick={closeConfirmation} disabled={isPending}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={clearCache} disabled={isPending}>
            {isPending ? 'Clearing…' : 'Clear cache'}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}
